import { useEffect } from 'react';
import useAuthStore from '../store/authStore';
import useCategoryStore from '../store/categoryStore';

const useInitializeFamily = () => {
  const { userProfile } = useAuthStore();
  const { initializeDefaultCategories, subscribeToCategories } = useCategoryStore();

  useEffect(() => {
    const initializeFamily = async () => {
      if (userProfile?.familyId) {
        // Initialize default categories if this is a new family
        await initializeDefaultCategories(userProfile.familyId, userProfile.uid);
        
        // Subscribe to categories
        subscribeToCategories(userProfile.familyId);
      }
    };

    initializeFamily();

    // Cleanup on unmount
    return () => {
      const { cleanup } = useCategoryStore.getState();
      cleanup();
    };
  }, [userProfile?.familyId, userProfile?.uid, initializeDefaultCategories, subscribeToCategories]);
};

export default useInitializeFamily;

